import { UseMutationResult } from '@tanstack/react-query'
import { type ResponseError } from '@/api/base/useApi'
import useApiPost from '@/api/base/useApiPost'
import type { ActionPoint, ActionPointText, RiskZoneId, SurveyGroup, Topic } from '@/types'

export type UpdateActionPointVars = {
  id: string
  dimension: ActionPoint['dimension']
  zone: RiskZoneId
  topic: Topic['id']
  priority: number
  texts: {
    de: ActionPointText
    en: ActionPointText
  }
  surveyGroupType: SurveyGroup.EMPLOYEE | SurveyGroup.PARTNER | SurveyGroup.CUSTOMER
}

async function updateActionPoint(
  accessToken: string | undefined,
  userId: string | undefined,
  variables: UpdateActionPointVars,
) {
  if (!accessToken) {
    return Promise.reject('No access token (updateActionPoint).')
  }
  if (!variables?.id) {
    return Promise.reject('No action point given.')
  }

  const url = `${process.env['NEXT_PUBLIC_API_ENDPOINT']}actionpoints/${variables.id}`

  console.log('[updateActionPoint] with', variables)

  const requestHeaders: any = {
    Authorization: 'Bearer ' + accessToken,
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'auth0-user-id': userId,
  }
  const response = await fetch(url, {
    method: 'PUT',
    headers: requestHeaders,
    body: JSON.stringify(variables),
  })

  if (!response.ok) {
    console.log('[updateActionPoint] Error', response)
    const json: ResponseError = await response.json()
    return Promise.reject(json)
  }

  return response.json()
}

type MutationFunction = () => UseMutationResult<ActionPoint, any, UpdateActionPointVars, any>

const useActionPointUpdateV1: MutationFunction = () => useApiPost(updateActionPoint)

export default useActionPointUpdateV1
